var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbCollapseDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-collapse-down_svg__clip0_1296_2504)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.388 3.779a.952.952 0 010 1.347L7.673 10.84a.952.952 0 01-1.347 0L.612 5.126A.952.952 0 011.96 3.779l5.04 5.04 5.042-5.04a.952.952 0 011.347 0z",
    fill: "#58647A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-collapse-down_svg__clip0_1296_2504"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.333 .833)",
    d: "M0 0h13.333v13.333H0z"
  })))));
}

export default SvgIbCollapseDown;